import { ReactNode } from "react";

interface IAreaTitle {
    title: string,
    step: string
    children: ReactNode
    zIndex?: string
}

const AreaTitle = ({ title, step, children, zIndex }: IAreaTitle) => {
    return (
        <div className={`relative flex flex-col bg-white rounded-lg ${zIndex}`}>
            <div className={`sticky top-15 bg-white rounded-t-lg flex items-center gap-3 px-10 py-6 border-b-2 border-[#F8F8FA] font-semibold ${zIndex} tablet:px-4 tablet:py-4`}>
                <p className={`bg-primary text-white px-3.5 py-2 rounded-full tablet:text-sm`}>STEP {step}</p>
                <p className='tablet:text-lg text-2xl'>{title}</p>
            </div>
            {children}
        </div>
    )
}

export default AreaTitle